<template>
  <div class="custom-card">
    <button class="accordion">{{ title }}</button>
    <div class="panel">
      <hr />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    snake_case_string(str) {
      return (
        str &&
        str
          .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
          .map((s) => s.toLowerCase())
          .join("_")
      );
    },
  },
};
</script>

<style scoped>
.accordion {
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
}

.active,
.accordion:hover {
  /* background-color: #ccc; */
  font-weight: bold;
}

.a-box {
  box-shadow: 0px 0px 10px 2px rgb(0 0 0 / 4%);
  border-radius: 8px;
  /* padding: 1rem; */
  background-color: white;
  border-radius: 10px;
}
.panel {
  padding: 0 18px;
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  height: 100%;
}
.accordion:after {
  content: "\02C4"; /* Unicode character for "plus" sign (+) */
  font-size: 13px;
  color: #777;
  float: right;
  margin-left: 5px;
}

.active:after {
  content: "\02C5"; /* Unicode character for "minus" sign (-) */
}
</style>
